import { ChangeDetectorRef, Component } from '@angular/core'
import { StyleLoaderService } from './../core/style-loader/style-loader.service'
import { BreakpointsService } from './../core/breakpoints/breakpoints.service'
import { SeDialogComponent, SeDialogHelper } from './../dialog'
import { SeModalOptions, SeModalAction } from './modal-types'

let MODAL_COUNTER: number = 1

@Component({
  standalone: false,
  selector: 'se-modal',
  templateUrl: './modal.component.html',
  
})
export class SeModalComponent extends SeDialogComponent {

  public cancel: () => void
  public title: string
  public id: string = `se-modal-${MODAL_COUNTER++}-${Date.now()}`

  constructor(
    protected styleLoaderService: StyleLoaderService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected breakpointsService: BreakpointsService,
    protected dialogHelper: SeDialogHelper,
  ) {
    super(styleLoaderService, changeDetectorRef, dialogHelper)
  }

  public setOptions(options: SeModalOptions): void {
    if (!options) return

    super.setOptions(options)
    this.setTitle(options.title)
  }

  public setActions(actions: SeModalAction[]): void {
    this.isValid = false
    if (!actions) return

    const cancel = actions.filter(action => !!action.action && !!action.cancel)[0]

    if (!cancel) return this.error('You must provide a cancel action')

    this.cancel = cancel.action
    super.setActions(actions)
  }

  public setTitle(title: string): void {
    this.title = title
  }

  protected duration(): number {
    if (!this.breakpointsService.isMobile()) return super.duration()
    const durations = this.durations
    return durations.slide = durations.slide || this.styleLoaderService.getVariable('se-modal-animation-duration-slide').value
  }

  public classes(): string {
    return `se-modal ${super.classes()}`
  }

}
